import { useState } from "react";
import PageSEO from "@/components/PageSEO";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Zap,
  ArrowLeft,
  ExternalLink,
  CheckCircle2,
  Circle,
  Clock,
  Search,
  ChevronRight,
} from "lucide-react";

// ── Static catalog data (mirrors backend OEM_CATALOG + OEM_DIRECTORY) ─────────

const PRODUCTS = [
  // ── DC Fast ──────────────────────────────────────────────────────────────
  { brand: "Tata Power EV",    model: "EZ Charge 30",        power_kw: 30,  price_inr: 500000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.tatapower.com/ev-charging" },
  { brand: "Tata Power EV",    model: "EZ Charge 60",        power_kw: 60,  price_inr: 850000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.tatapower.com/ev-charging" },
  { brand: "Tata Power EV",    model: "EZ Charge 120",       power_kw: 120, price_inr: 1600000, warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.tatapower.com/ev-charging" },
  { brand: "Exicom",           model: "FE-30",               power_kw: 30,  price_inr: 450000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.exicom.in/ev-charger" },
  { brand: "Exicom",           model: "FE-60",               power_kw: 60,  price_inr: 820000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.exicom.in/ev-charger" },
  { brand: "Exicom",           model: "FE-120",              power_kw: 120, price_inr: 1550000, warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.exicom.in/ev-charger" },
  { brand: "Delta Electronics",model: "DC Wallbox 30",       power_kw: 30,  price_inr: 480000,  warranty_years: 2, ccs2: true,  chademo: true,  bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.delta-india.com/ev-charger" },
  { brand: "Delta Electronics",model: "DC Fast Charger 60",  power_kw: 60,  price_inr: 900000,  warranty_years: 2, ccs2: true,  chademo: true,  bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.delta-india.com/ev-charger" },
  { brand: "Delta Electronics",model: "HV 120",              power_kw: 120, price_inr: 1650000, warranty_years: 2, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "DC_fast", website: "https://www.delta-india.com/ev-charger" },
  { brand: "ABB",              model: "Terra 54",            power_kw: 50,  price_inr: 950000,  warranty_years: 3, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "DC_fast", website: "https://new.abb.com/ev-charging" },
  { brand: "ABB",              model: "Terra 124",           power_kw: 120, price_inr: 1800000, warranty_years: 3, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "DC_fast", website: "https://new.abb.com/ev-charging" },
  { brand: "Servotech",        model: "ST-EV-DC30",          power_kw: 30,  price_inr: 420000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.servotech.in" },
  { brand: "Servotech",        model: "ST-EV-DC60",          power_kw: 60,  price_inr: 750000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.servotech.in" },
  { brand: "Siemens",          model: "VersiCharge DC50",    power_kw: 50,  price_inr: 1000000, warranty_years: 3, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "DC_fast", website: "https://www.siemens.com/global/en/products/energy/electrification/e-mobility.html" },
  { brand: "Siemens",          model: "VersiCharge DC150",   power_kw: 150, price_inr: 2200000, warranty_years: 3, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "DC_fast", website: "https://www.siemens.com/global/en/products/energy/electrification/e-mobility.html" },
  { brand: "Magenta Power",    model: "ChargeGrid DC30",     power_kw: 30,  price_inr: 460000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://magentapower.com" },
  { brand: "Magenta Power",    model: "ChargeGrid DC60",     power_kw: 60,  price_inr: 780000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://magentapower.com" },
  { brand: "Jio-BP",           model: "Pulse 60",            power_kw: 60,  price_inr: 880000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.jiobp.com/ev-charging" },
  { brand: "Greaves Electric", model: "GreenBolt DC30",      power_kw: 30,  price_inr: 460000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.greavescotton.com" },
  { brand: "Kazam EV",         model: "Kazam DC30",          power_kw: 30,  price_inr: 430000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.kazam.in" },
  { brand: "Kazam EV",         model: "Kazam DC60",          power_kw: 60,  price_inr: 790000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.kazam.in" },
  { brand: "Okaya Power",      model: "OP-DC30",             power_kw: 30,  price_inr: 410000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.okayapower.com" },
  { brand: "Okaya Power",      model: "OP-DC60",             power_kw: 60,  price_inr: 760000,  warranty_years: 2, ccs2: true,  chademo: false, bharat_dc: true,  bharat_ac: false, category: "DC_fast", website: "https://www.okayapower.com" },
  // ── HPC / Supercharger ────────────────────────────────────────────────────
  { brand: "ChargePoint",      model: "CPE 100",             power_kw: 100, price_inr: 1500000, warranty_years: 3, ccs2: true,  chademo: false, bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://www.chargepoint.com" },
  { brand: "ChargePoint",      model: "Express 250",         power_kw: 250, price_inr: 3500000, warranty_years: 3, ccs2: true,  chademo: false, bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://www.chargepoint.com" },
  { brand: "ABB",              model: "Terra 184",           power_kw: 180, price_inr: 2900000, warranty_years: 3, ccs2: true,  chademo: false, bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://new.abb.com/ev-charging" },
  { brand: "ABB",              model: "Terra 360",           power_kw: 360, price_inr: 4500000, warranty_years: 3, ccs2: true,  chademo: false, bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://new.abb.com/ev-charging" },
  { brand: "Delta Electronics",model: "HV 180",              power_kw: 180, price_inr: 2800000, warranty_years: 3, ccs2: true,  chademo: true,  bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://www.delta-india.com/ev-charger" },
  { brand: "Siemens",          model: "VersiCharge DC300",   power_kw: 300, price_inr: 4200000, warranty_years: 3, ccs2: true,  chademo: false, bharat_dc: false, bharat_ac: false, category: "supercharger", website: "https://www.siemens.com/global/en/products/energy/electrification/e-mobility.html" },
  // ── AC Chargers ───────────────────────────────────────────────────────────
  { brand: "Tata Power EV",    model: "EZ Home 7.2",         power_kw: 7.2, price_inr: 35000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.tatapower.com/ev-charging" },
  { brand: "Tata Power EV",    model: "EZ Station 22",       power_kw: 22,  price_inr: 75000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.tatapower.com/ev-charging" },
  { brand: "Exicom",           model: "DuoSmart 7.4",        power_kw: 7.4, price_inr: 28000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.exicom.in/ev-charger" },
  { brand: "Exicom",           model: "DuoSmart 22",         power_kw: 22,  price_inr: 75000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.exicom.in/ev-charger" },
  { brand: "ABB",              model: "AC Wallbox 7",        power_kw: 7,   price_inr: 40000,   warranty_years: 3, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://new.abb.com/ev-charging" },
  { brand: "ABB",              model: "AC Wallbox 22",       power_kw: 22,  price_inr: 90000,   warranty_years: 3, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://new.abb.com/ev-charging" },
  { brand: "Servotech",        model: "ST-AC7.4",            power_kw: 7.4, price_inr: 25000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.servotech.in" },
  { brand: "Servotech",        model: "ST-AC22",             power_kw: 22,  price_inr: 68000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.servotech.in" },
  { brand: "Magenta Power",    model: "ChargeGrid AC7.4",    power_kw: 7.4, price_inr: 30000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://magentapower.com" },
  { brand: "Magenta Power",    model: "ChargeGrid AC22",     power_kw: 22,  price_inr: 72000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://magentapower.com" },
  { brand: "Delta Electronics",model: "AC Wallbox 7.4",      power_kw: 7.4, price_inr: 32000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.delta-india.com/ev-charger" },
  { brand: "Delta Electronics",model: "AC Wallbox 22",       power_kw: 22,  price_inr: 80000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.delta-india.com/ev-charger" },
  { brand: "Kazam EV",         model: "Kazam AC7.4",         power_kw: 7.4, price_inr: 26000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.kazam.in" },
  { brand: "Kazam EV",         model: "Kazam AC22",          power_kw: 22,  price_inr: 65000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.kazam.in" },
  { brand: "Greaves Electric", model: "GreenBolt AC7.4",     power_kw: 7.4, price_inr: 27000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.greavescotton.com" },
  { brand: "Okaya Power",      model: "OP-AC7.4",            power_kw: 7.4, price_inr: 24000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.okayapower.com" },
  { brand: "Okaya Power",      model: "OP-AC22",             power_kw: 22,  price_inr: 62000,   warranty_years: 2, ccs2: false, chademo: false, bharat_dc: false, bharat_ac: true,  category: "AC_slow", website: "https://www.okayapower.com" },
];

const OEM_DIRECTORY = [
  { brand: "Tata Power EV",    category: "Indian OEM & CPO",          website: "https://www.tatapower.com/ev-charging",                                                         strengths: "Largest public charging network in India; strong after-sales & AMC network",                      dc_range: "₹5L – ₹16L (30–120 kW)",       ac_range: "₹35K – ₹75K (7.2–22 kW)",  fame_eligible: true,  headquarters: "Mumbai" },
  { brand: "Exicom",           category: "Indian OEM",                 website: "https://www.exicom.in/ev-charger",                                                             strengths: "Listed company; widest model range; BIS-certified; strong FAME II track record",                   dc_range: "₹4.5L – ₹9L (30–120 kW)",     ac_range: "₹28K – ₹75K (7.4–22 kW)", fame_eligible: true,  headquarters: "Gurugram" },
  { brand: "Delta Electronics",category: "Global OEM (India ops)",     website: "https://www.delta-india.com/ev-charger",                                                       strengths: "Global reliability; CHAdeMO + CCS2; strong for highway/fleet deployments",                       dc_range: "₹4.8L – ₹16.5L (30–120 kW)", ac_range: "₹32K – ₹80K (7.4–22 kW)", fame_eligible: true,  headquarters: "Pune" },
  { brand: "ABB",              category: "Global OEM",                  website: "https://new.abb.com/ev-charging",                                                              strengths: "Premium global brand; Terra series battle-tested; 3-yr warranty; best for premium sites",         dc_range: "₹9.5L – ₹45L (50–360 kW)",   ac_range: "₹40K – ₹90K (7–22 kW)",   fame_eligible: false, headquarters: "Bangalore (India HQ)" },
  { brand: "Servotech",        category: "Indian OEM",                  website: "https://www.servotech.in",                                                                     strengths: "Cost-competitive; BIS certified; good for Tier 2/3 cities; FAME II eligible",                    dc_range: "₹4.2L – ₹7.5L (30–60 kW)",   ac_range: "₹25K – ₹68K (7.4–22 kW)", fame_eligible: true,  headquarters: "New Delhi" },
  { brand: "Siemens",          category: "Global OEM",                  website: "https://www.siemens.com/global/en/products/energy/electrification/e-mobility.html",           strengths: "Enterprise-grade reliability; smart grid integration; suitable for large commercial sites",       dc_range: "₹10L – ₹42L (50–300 kW)",    ac_range: "N/A",                       fame_eligible: false, headquarters: "Mumbai (India HQ)" },
  { brand: "ChargePoint",      category: "Global OEM & CPO",           website: "https://www.chargepoint.com",                                                                  strengths: "World's largest charging network; advanced CMS; ideal for fleet and commercial",                  dc_range: "₹15L – ₹35L (100–250 kW)",   ac_range: "N/A",                       fame_eligible: false, headquarters: "US (India via partners)" },
  { brand: "Magenta Power",    category: "Indian OEM & CPO",           website: "https://magentapower.com",                                                                     strengths: "India-manufactured; strong in residential & commercial; ChargeGrid platform",                     dc_range: "₹4.6L – ₹7.8L (30–60 kW)",  ac_range: "₹30K – ₹72K (7.4–22 kW)", fame_eligible: true,  headquarters: "Mumbai" },
  { brand: "Jio-BP",           category: "Indian CPO (fuel retail + EV)", website: "https://www.jiobp.com/ev-charging",                                                         strengths: "Backed by Reliance & BP; rapid expansion at petrol stations; 24×7 ops",                          dc_range: "₹8.5L – ₹10L (60 kW)",       ac_range: "N/A",                       fame_eligible: true,  headquarters: "Mumbai" },
  { brand: "Greaves Electric", category: "Indian OEM",                  website: "https://www.greavescotton.com",                                                                strengths: "Legacy engineering brand; strong 2W/3W focus; BIS certified DC chargers",                        dc_range: "₹4.6L – ₹6L (30 kW)",       ac_range: "₹27K – ₹65K (7.4 kW)",    fame_eligible: true,  headquarters: "Mumbai" },
  { brand: "Kazam EV",         category: "Indian OEM & CPO",           website: "https://www.kazam.in",                                                                         strengths: "Smart charging platform; IoT-first design; competitive pricing; OCPP 1.6/2.0",                  dc_range: "₹4.3L – ₹7.9L (30–60 kW)",  ac_range: "₹26K – ₹65K (7.4–22 kW)", fame_eligible: true,  headquarters: "Bangalore" },
  { brand: "Okaya Power",      category: "Indian OEM",                  website: "https://www.okayapower.com",                                                                   strengths: "Battery + EV charger manufacturer; cost-effective; growing dealer network",                      dc_range: "₹4.1L – ₹7.6L (30–60 kW)",  ac_range: "₹24K – ₹62K (7.4–22 kW)", fame_eligible: true,  headquarters: "New Delhi" },
  { brand: "NTPC EV",          category: "PSU CPO",                     website: "https://www.ntpc.co.in",                                                                       strengths: "Government-backed; nationwide expansion mandate; suitable for public land partnerships",         dc_range: "Project-based",               ac_range: "Project-based",             fame_eligible: true,  headquarters: "New Delhi" },
  { brand: "EESL",             category: "PSU CPO & Procurement",       website: "https://www.eeslindia.org",                                                                    strengths: "Bulk procurement agency; heavily subsidised; ideal for government / municipal projects",          dc_range: "Project-based procurement",   ac_range: "Project-based procurement", fame_eligible: true,  headquarters: "New Delhi" },
];

// ── Brand theme map ────────────────────────────────────────────────────────────
const BRAND_THEMES = {
  "Tata Power EV":    { from: "#1e3a5f", to: "#0f7dc2", accent: "#38bdf8" },
  "Exicom":           { from: "#1a1a2e", to: "#e94560", accent: "#f472b6" },
  "Delta Electronics":{ from: "#003366", to: "#0070cc", accent: "#60a5fa" },
  "ABB":              { from: "#1c1c1c", to: "#cc0000", accent: "#f87171" },
  "Servotech":        { from: "#0d2b1f", to: "#16a34a", accent: "#4ade80" },
  "Siemens":          { from: "#003d6b", to: "#009999", accent: "#5eead4" },
  "ChargePoint":      { from: "#1a1a1a", to: "#f97316", accent: "#fb923c" },
  "Magenta Power":    { from: "#4a004a", to: "#d946ef", accent: "#f0abfc" },
  "Jio-BP":           { from: "#1e293b", to: "#0ea5e9", accent: "#7dd3fc" },
  "Greaves Electric": { from: "#1e1b4b", to: "#6366f1", accent: "#a5b4fc" },
  "Kazam EV":         { from: "#082f49", to: "#0284c7", accent: "#7dd3fc" },
  "Okaya Power":      { from: "#1c1917", to: "#78716c", accent: "#d4d0cb" },
  "NTPC EV":          { from: "#172554", to: "#1d4ed8", accent: "#93c5fd" },
  "EESL":             { from: "#14532d", to: "#15803d", accent: "#86efac" },
};
const DEFAULT_THEME = { from: "#1e293b", to: "#475569", accent: "#94a3b8" };

// ── Real product photos (one per brand; fallback to SVG illustration) ──────────
const BRAND_IMAGES = {
  "ABB":               "/chargers/abb.jpg",
  "Delta Electronics": "/chargers/delta.jpg",
  "Exicom":            "/chargers/exicom.jpg",
  "Greaves Electric":  "/chargers/greaves.jpg",
  "Okaya Power":       "/chargers/okaya.jpg",
  "Servotech":         "/chargers/servotech.png",
  "Siemens":           "/chargers/siemens.png",
  "Tata Power EV":     "/chargers/tata.png",
};

// Per-brand image display tuning: objectPosition, bg color, padding
const BRAND_IMAGE_STYLE = {
  "ABB":              { bg: "#f5f5f5", objectPosition: "center center", padding: "8px" },
  "Delta Electronics":{ bg: "#f5f5f5", objectPosition: "center center", padding: "8px" },
  "Exicom":           { bg: "#e8eef2", objectPosition: "center 35%",    padding: "0px" },
  "Greaves Electric": { bg: "#0d0e10", objectPosition: "center center", padding: "4px" },
  "Okaya Power":      { bg: "#f5f5f5", objectPosition: "72% center",    padding: "6px" },
  "Servotech":        { bg: "#f5f5f5", objectPosition: "center 8%",     padding: "6px" },
  "Siemens":          { bg: "#f5f5f5", objectPosition: "center center", padding: "8px" },
  "Tata Power EV":    { bg: "#d4e8c2", objectPosition: "center center", padding: "6px" },
};

const POWER_FILTERS = [
  { label: "All Products",     value: "all" },
  { label: "≤ 30 kW DC",      value: "30" },
  { label: "50–60 kW DC",     value: "60" },
  { label: "120–150 kW DC",   value: "120" },
  { label: "180 kW+ / HPC",   value: "hpc" },
  { label: "AC Chargers",      value: "ac" },
];

const POWER_TIERS = [
  { label: "30 kW — Entry DC Fast",       color: "from-blue-600 to-cyan-500",    filter: p => p.category === "DC_fast" && p.power_kw <= 30 },
  { label: "50–60 kW — Mid-Range DC",     color: "from-violet-600 to-blue-500",  filter: p => p.category === "DC_fast" && p.power_kw > 30 && p.power_kw <= 90 },
  { label: "120–150 kW — High Power DC",  color: "from-orange-500 to-red-500",   filter: p => p.category === "DC_fast" && p.power_kw > 90 && p.power_kw <= 170 },
  { label: "180 kW+ — HPC / Supercharger",color: "from-rose-600 to-pink-500",    filter: p => p.category === "supercharger" },
  { label: "AC Chargers (7–22 kW)",       color: "from-emerald-600 to-teal-500", filter: p => p.category === "AC_slow" },
];

// ── SVG Charger Illustrations ─────────────────────────────────────────────────

function DCPillarSMSVG({ accent, from, to, uid, power }) {
  return (
    <svg viewBox="0 0 160 210" className="absolute inset-0 w-full h-full">
      <defs>
        <linearGradient id={`cg-b-${uid}`} x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#1e293b" /><stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
      </defs>
      <ellipse cx="80" cy="105" rx="68" ry="100" fill={from} opacity="0.3" />
      <ellipse cx="80" cy="200" rx="38" ry="5" fill="rgba(0,0,0,0.45)" />
      <rect x="42" y="197" width="76" height="6" rx="2" fill="#0f172a" />
      <polygon points="112,38 120,43 120,193 112,189" fill="rgba(255,255,255,0.04)" />
      <rect x="36" y="32" width="76" height="160" rx="8" fill={`url(#cg-b-${uid})`} />
      <rect x="36" y="38" width="2.5" height="146" rx="1" fill="rgba(255,255,255,0.06)" />
      <rect x="36" y="32" width="76" height="5" rx="2" fill={accent} />
      <rect x="48" y="54" width="56" height="62" rx="5" fill="#020810" />
      <rect x="50" y="56" width="52" height="58" rx="4" fill="#060d1a" />
      <rect x="50" y="56" width="52" height="58" rx="4" fill={accent} opacity="0.08" />
      <text x="76" y="84" textAnchor="middle" fill={accent} fontSize="20" fontWeight="bold" fontFamily="monospace">{power}</text>
      <text x="76" y="96" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="sans-serif">kW DC FAST</text>
      <rect x="54" y="106" width="44" height="3" rx="1.5" fill="rgba(255,255,255,0.08)" />
      <rect x="54" y="106" width="29" height="3" rx="1.5" fill={accent} opacity="0.85" />
      <circle cx="55" cy="121" r="3.5" fill={accent} />
      <text x="63" y="124" fill="rgba(255,255,255,0.4)" fontSize="7.5" fontFamily="sans-serif">READY</text>
      <line x1="48" y1="132" x2="102" y2="132" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
      <rect x="52" y="142" width="50" height="36" rx="6" fill="#020810" />
      <rect x="55" y="145" width="44" height="30" rx="5" fill="#0a1428" />
      <circle cx="66" cy="155" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.12)" strokeWidth="0.75" />
      <circle cx="77" cy="155" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.12)" strokeWidth="0.75" />
      <rect x="59" y="161" width="35" height="10" rx="3.5" fill="#1e293b" stroke="rgba(255,255,255,0.08)" strokeWidth="0.5" />
      <circle cx="68" cy="166" r="2.5" fill="#0f172a" /><circle cx="77" cy="166" r="2.5" fill="#0f172a" />
      <rect x="55" y="145" width="44" height="30" rx="5" stroke={accent} strokeWidth="0.75" fill="none" strokeOpacity="0.35" />
      <path d="M 88 178 C 90 193 115 190 118 202" stroke={accent} strokeWidth="3" fill="none" strokeOpacity="0.6" strokeLinecap="round" />
      <rect x="112" y="200" width="14" height="9" rx="2.5" fill="#1e293b" stroke={accent} strokeWidth="0.75" strokeOpacity="0.5" />
    </svg>
  );
}

function DCPillarHDSVG({ accent, from, to, uid, power }) {
  return (
    <svg viewBox="0 0 160 210" className="absolute inset-0 w-full h-full">
      <defs>
        <linearGradient id={`cg-b-${uid}`} x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#1e293b" /><stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
      </defs>
      <ellipse cx="80" cy="105" rx="72" ry="100" fill={from} opacity="0.28" />
      <ellipse cx="80" cy="200" rx="48" ry="6" fill="rgba(0,0,0,0.45)" />
      <rect x="26" y="196" width="108" height="6" rx="2" fill="#0f172a" />
      <polygon points="124,34 132,40 132,192 124,188" fill="rgba(255,255,255,0.04)" />
      <rect x="20" y="28" width="104" height="166" rx="8" fill={`url(#cg-b-${uid})`} />
      <rect x="20" y="34" width="2.5" height="152" rx="1" fill="rgba(255,255,255,0.07)" />
      <rect x="20" y="28" width="104" height="5" rx="2" fill={accent} />
      <rect x="30" y="46" width="84" height="66" rx="5" fill="#020810" />
      <rect x="32" y="48" width="80" height="62" rx="4" fill="#060d1a" />
      <rect x="32" y="48" width="80" height="62" rx="4" fill={accent} opacity="0.08" />
      <text x="72" y="77" textAnchor="middle" fill={accent} fontSize="24" fontWeight="bold" fontFamily="monospace">{power}</text>
      <text x="72" y="90" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="8" fontFamily="sans-serif">kW HIGH POWER DC</text>
      <circle cx="43" cy="104" r="4" fill={accent} opacity="0.9" />
      <text x="51" y="107" fill="rgba(255,255,255,0.45)" fontSize="7" fontFamily="sans-serif">GUN A — ACTIVE</text>
      <circle cx="43" cy="116" r="4" fill="rgba(255,255,255,0.15)" />
      <text x="51" y="119" fill="rgba(255,255,255,0.2)" fontSize="7" fontFamily="sans-serif">GUN B — STANDBY</text>
      <line x1="30" y1="126" x2="114" y2="126" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
      <rect x="28" y="134" width="44" height="36" rx="5" fill="#020810" />
      <rect x="31" y="137" width="38" height="30" rx="4" fill="#0a1428" />
      <circle cx="42" cy="148" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.12)" strokeWidth="0.75" />
      <circle cx="53" cy="148" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.12)" strokeWidth="0.75" />
      <rect x="35" y="154" width="28" height="9" rx="3.5" fill="#1e293b" />
      <circle cx="45" cy="158.5" r="2.5" fill="#0f172a" /><circle cx="54" cy="158.5" r="2.5" fill="#0f172a" />
      <rect x="31" y="137" width="38" height="30" rx="4" stroke={accent} strokeWidth="1" fill="none" strokeOpacity="0.45" />
      <rect x="82" y="134" width="44" height="36" rx="5" fill="#020810" />
      <rect x="85" y="137" width="38" height="30" rx="4" fill="#0a1428" />
      <circle cx="96" cy="148" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.08)" strokeWidth="0.5" />
      <circle cx="107" cy="148" r="3" fill="#1e293b" stroke="rgba(255,255,255,0.08)" strokeWidth="0.5" />
      <rect x="89" y="154" width="28" height="9" rx="3.5" fill="#1e293b" />
      <circle cx="99" cy="158.5" r="2.5" fill="#0f172a" /><circle cx="108" cy="158.5" r="2.5" fill="#0f172a" />
      <rect x="85" y="137" width="38" height="30" rx="4" stroke="rgba(255,255,255,0.12)" strokeWidth="0.5" fill="none" />
      <path d="M 54 170 C 54 187 28 185 24 200" stroke={accent} strokeWidth="3.5" fill="none" strokeOpacity="0.65" strokeLinecap="round" />
      <path d="M 100 170 C 100 187 132 185 136 200" stroke="rgba(255,255,255,0.2)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <rect x="17" y="198" width="14" height="9" rx="2.5" fill="#1e293b" stroke={accent} strokeWidth="0.75" strokeOpacity="0.5" />
      <rect x="130" y="198" width="14" height="9" rx="2.5" fill="#1e293b" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
    </svg>
  );
}

function HPCSuperchargerSVG({ accent, from, to, uid, power }) {
  return (
    <svg viewBox="0 0 160 210" className="absolute inset-0 w-full h-full">
      <defs>
        <linearGradient id={`cg-b-${uid}`} x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#1e293b" /><stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
        <linearGradient id={`cg-led-${uid}`} x1="0" y1="0" x2="0" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor={accent} /><stop offset="100%" stopColor={accent} stopOpacity="0.05" />
        </linearGradient>
      </defs>
      <ellipse cx="80" cy="100" rx="75" ry="100" fill={accent} opacity="0.14" />
      <ellipse cx="80" cy="200" rx="50" ry="6" fill="rgba(0,0,0,0.5)" />
      <rect x="24" y="196" width="112" height="6" rx="2" fill="#0f172a" />
      <polygon points="122,28 132,34 132,192 122,188" fill="rgba(255,255,255,0.05)" />
      <rect x="18" y="20" width="104" height="172" rx="8" fill={`url(#cg-b-${uid})`} />
      <rect x="18" y="26" width="2.5" height="158" rx="1" fill="rgba(255,255,255,0.08)" />
      <rect x="119" y="20" width="5" height="172" rx="2" fill={`url(#cg-led-${uid})`} opacity="0.9" />
      <rect x="18" y="20" width="104" height="6" rx="2" fill={accent} />
      <text x="70" y="40" textAnchor="middle" fill={accent} fontSize="7.5" fontWeight="bold" fontFamily="sans-serif" opacity="0.7">ULTRA-FAST CHARGING</text>
      <rect x="26" y="48" width="88" height="72" rx="5" fill="#020810" />
      <rect x="28" y="50" width="84" height="68" rx="4" fill="#060d1a" />
      <rect x="28" y="50" width="84" height="68" rx="4" fill={accent} opacity="0.1" />
      <text x="70" y="82" textAnchor="middle" fill={accent} fontSize="28" fontWeight="bold" fontFamily="monospace">{power}</text>
      <text x="70" y="95" textAnchor="middle" fill="rgba(255,255,255,0.25)" fontSize="8" fontFamily="sans-serif">kW ULTRA-FAST DC</text>
      {[0,1,2,3,4].map(i => (
        <rect key={i} x={32 + i*16} y="107" width="12" height="5" rx="2" fill={i < 4 ? accent : "rgba(255,255,255,0.08)"} opacity={i < 4 ? 1 - i*0.12 : 1} />
      ))}
      <circle cx="36" cy="127" r="4.5" fill={accent} opacity="0.9" />
      <text x="46" y="130" fill="rgba(255,255,255,0.5)" fontSize="7.5" fontFamily="sans-serif">ACTIVE — 98% EFF.</text>
      <line x1="28" y1="138" x2="112" y2="138" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
      <rect x="26" y="146" width="44" height="38" rx="5" fill="#020810" />
      <rect x="29" y="149" width="38" height="32" rx="4" fill="#0a1428" />
      <circle cx="40" cy="161" r="3.5" fill="#1e293b" stroke={accent} strokeWidth="0.5" strokeOpacity="0.5" />
      <circle cx="52" cy="161" r="3.5" fill="#1e293b" stroke={accent} strokeWidth="0.5" strokeOpacity="0.5" />
      <rect x="33" y="167" width="28" height="10" rx="3.5" fill="#1e293b" />
      <circle cx="43" cy="172" r="2.5" fill="#0f172a" /><circle cx="52" cy="172" r="2.5" fill="#0f172a" />
      <rect x="29" y="149" width="38" height="32" rx="4" stroke={accent} strokeWidth="1" fill="none" strokeOpacity="0.55" />
      <rect x="80" y="146" width="44" height="38" rx="5" fill="#020810" />
      <rect x="83" y="149" width="38" height="32" rx="4" fill="#0a1428" />
      <circle cx="94" cy="161" r="3.5" fill="#1e293b" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="106" cy="161" r="3.5" fill="#1e293b" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <rect x="87" y="167" width="28" height="10" rx="3.5" fill="#1e293b" />
      <circle cx="97" cy="172" r="2.5" fill="#0f172a" /><circle cx="106" cy="172" r="2.5" fill="#0f172a" />
      <rect x="83" y="149" width="38" height="32" rx="4" stroke="rgba(255,255,255,0.12)" strokeWidth="0.5" fill="none" />
      <path d="M 50 184 C 50 198 22 196 18 206" stroke={accent} strokeWidth="4.5" fill="none" strokeOpacity="0.7" strokeLinecap="round" />
      <path d="M 104 184 C 104 198 140 196 144 206" stroke="rgba(255,255,255,0.22)" strokeWidth="4" fill="none" strokeLinecap="round" />
      <rect x="10" y="203" width="16" height="10" rx="3" fill="#1e293b" stroke={accent} strokeWidth="1" strokeOpacity="0.65" />
      <rect x="138" y="203" width="16" height="10" rx="3" fill="#1e293b" stroke="rgba(255,255,255,0.18)" strokeWidth="0.75" />
    </svg>
  );
}

function ACWallboxSVG({ accent, from, to, uid, power }) {
  return (
    <svg viewBox="0 0 160 210" className="absolute inset-0 w-full h-full">
      <defs>
        <linearGradient id={`cg-b-${uid}`} x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#1e293b" /><stop offset="100%" stopColor="#0f172a" />
        </linearGradient>
      </defs>
      <ellipse cx="80" cy="115" rx="60" ry="85" fill={from} opacity="0.28" />
      <rect x="15" y="30" width="130" height="145" rx="6" fill="rgba(0,0,0,0.2)" />
      <ellipse cx="80" cy="182" rx="48" ry="5" fill="rgba(0,0,0,0.35)" />
      <polygon points="118,44 126,50 126,176 118,172" fill="rgba(255,255,255,0.04)" />
      <rect x="24" y="38" width="94" height="136" rx="10" fill={`url(#cg-b-${uid})`} />
      <rect x="24" y="44" width="2.5" height="122" rx="1" fill="rgba(255,255,255,0.07)" />
      <rect x="24" y="38" width="94" height="5" rx="2" fill={accent} />
      <rect x="36" y="56" width="70" height="54" rx="5" fill="#020810" />
      <rect x="38" y="58" width="66" height="50" rx="4" fill="#060d1a" />
      <rect x="38" y="58" width="66" height="50" rx="4" fill={accent} opacity="0.08" />
      <text x="71" y="82" textAnchor="middle" fill={accent} fontSize="18" fontWeight="bold" fontFamily="monospace">{power}</text>
      <text x="71" y="94" textAnchor="middle" fill="rgba(255,255,255,0.3)" fontSize="7.5" fontFamily="sans-serif">kW AC SMART</text>
      <rect x="42" y="100" width="58" height="3" rx="1.5" fill="rgba(255,255,255,0.08)" />
      <rect x="42" y="100" width="40" height="3" rx="1.5" fill={accent} opacity="0.8" />
      <circle cx="44" cy="115" r="3.5" fill={accent} opacity="0.85" />
      <text x="52" y="118" fill="rgba(255,255,255,0.4)" fontSize="7.5" fontFamily="sans-serif">READY</text>
      <rect x="38" y="126" width="66" height="36" rx="6" fill="#020810" />
      <rect x="41" y="129" width="60" height="30" rx="5" fill="#0a1428" />
      <circle cx="71" cy="144" r="12" fill="#1e293b" stroke={accent} strokeWidth="0.75" strokeOpacity="0.4" />
      <circle cx="71" cy="135" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="80" cy="139.5" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="79" cy="150" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="71" cy="153" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="63" cy="150" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="63" cy="139.5" r="2.5" fill="#0f172a" stroke="rgba(255,255,255,0.1)" strokeWidth="0.5" />
      <circle cx="71" cy="144" r="2" fill={accent} opacity="0.6" />
      <rect x="41" y="129" width="60" height="30" rx="5" stroke={accent} strokeWidth="0.75" fill="none" strokeOpacity="0.3" />
      <rect x="40" y="168" width="30" height="12" rx="3" fill="#020810" />
      <rect x="43" y="170" width="24" height="8" rx="2" fill="#0a1428" />
      <rect x="46" y="173" width="8" height="3" rx="1" fill={accent} opacity="0.5" />
      <path d="M 74 162 C 76 180 105 178 108 193" stroke={accent} strokeWidth="3" fill="none" strokeOpacity="0.6" strokeLinecap="round" />
      <line x1="108" y1="193" x2="108" y2="204" stroke={accent} strokeWidth="3" strokeOpacity="0.4" strokeLinecap="round" />
      <rect x="102" y="202" width="13" height="8" rx="2" fill="#1e293b" stroke={accent} strokeWidth="0.75" strokeOpacity="0.5" />
    </svg>
  );
}

function ChargerIllustration({ category, power_kw, theme, uid }) {
  const { from, to, accent } = theme;
  if (category === "AC_slow")     return <ACWallboxSVG accent={accent} from={from} to={to} uid={uid} power={power_kw} />;
  if (category === "supercharger") return <HPCSuperchargerSVG accent={accent} from={from} to={to} uid={uid} power={power_kw} />;
  if (power_kw >= 100)             return <DCPillarHDSVG accent={accent} from={from} to={to} uid={uid} power={power_kw} />;
  return <DCPillarSMSVG accent={accent} from={from} to={to} uid={uid} power={power_kw} />;
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function getBrandInitials(brand) {
  return brand.split(/[\s/\-&]+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join("");
}

function formatINR(n) {
  if (!n) return "—";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)} Cr`;
  if (n >= 100000)   return `₹${(n / 100000).toFixed(1)} L`;
  if (n >= 1000)     return `₹${(n / 1000).toFixed(0)} K`;
  return `₹${n}`;
}

// ── Connector chip ────────────────────────────────────────────────────────────
function ConnectorChip({ label, active }) {
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border"
      style={active
        ? { backgroundColor: "#edf8f4", borderColor: "#B2E6D4", color: "#689689" }
        : { backgroundColor: "#f5f2ec", borderColor: "#B2E6D4", color: "#4a7068" }
      }
    >
      {active
        ? <CheckCircle2 className="w-2.5 h-2.5" />
        : <Circle className="w-2.5 h-2.5" />}
      {label}
    </span>
  );
}

// ── Product card ──────────────────────────────────────────────────────────────
function ProductCard({ product }) {
  const theme = BRAND_THEMES[product.brand] || DEFAULT_THEME;
  const isFame = product.bharat_dc || product.bharat_ac;
  const uid = (product.brand + product.model).replace(/[^a-zA-Z0-9]/g, "").slice(0, 18);
  const imgSrc = BRAND_IMAGES[product.brand] || null;
  const imgCfg = BRAND_IMAGE_STYLE[product.brand] || {};

  return (
    <div className="group rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" style={{ border: "1px solid #B2E6D4", backgroundColor: "#ffffff" }}>
      {/* Image / Illustration header */}
      <div className="relative h-52 overflow-hidden"
        style={imgSrc
          ? { background: imgCfg.bg || "#f5f5f5" }
          : { background: `linear-gradient(135deg, ${theme.from} 0%, ${theme.to} 100%)` }}
      >
        {imgSrc ? (
          <>
            {/* Subtle brand-tinted vignette — invisible on dark-bg images */}
            <div className="absolute inset-0" style={{
              background: `radial-gradient(ellipse at 50% 85%, ${theme.to}1a 0%, transparent 70%)`,
              zIndex: 0,
            }} />
            {/* Product photo — uniform object-contain with per-brand tuning */}
            <img
              src={imgSrc}
              alt={`${product.brand} EV charger`}
              className="absolute inset-0 w-full h-full object-contain"
              style={{
                padding: imgCfg.padding ?? "8px",
                zIndex: 1,
                objectPosition: imgCfg.objectPosition || "center center",
              }}
            />
          </>
        ) : (
          <ChargerIllustration
            category={product.category}
            power_kw={product.power_kw}
            theme={theme}
            uid={uid}
          />
        )}

        {/* Category badge */}
        <span
          className="absolute top-3 left-3 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-widest z-10"
          style={{ background: `${theme.from}dd`, color: theme.accent }}
        >
          {product.category === "AC_slow" ? "AC" : product.category === "supercharger" ? "HPC" : "DC Fast"}
        </span>

        {isFame && (
          <span className="absolute top-3 right-3 text-[10px] font-bold px-2 py-0.5 rounded-full z-10" style={{ backgroundColor: "#689689", color: "#ffffff" }}>
            FAME II ✓
          </span>
        )}

        {/* Brand + power name-plate at bottom — always on a dark scrim */}
        <div
          className="absolute bottom-0 left-0 right-0 px-4 pt-10 pb-3 z-10 pointer-events-none"
          style={{
            background: `linear-gradient(to top, ${theme.from}f2 0%, ${theme.from}99 45%, transparent 100%)`,
          }}
        >
          <p className="text-white font-black text-2xl leading-none">
            {product.power_kw}<span className="text-base font-semibold opacity-60 ml-1">kW</span>
          </p>
          <p className="text-white/75 text-[11px] font-semibold tracking-wide mt-0.5 uppercase">{product.brand}</p>
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 p-4 flex flex-col gap-3">
        <div>
          <p className="font-bold text-sm leading-tight" style={{ color: "#504136" }}>{product.model}</p>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-lg p-2" style={{ backgroundColor: "#f5f2ec" }}>
            <p className="text-[10px] mb-0.5" style={{ color: "#4a7068" }}>Price (ex-works)</p>
            <p className="font-bold text-sm" style={{ color: "#504136" }}>{formatINR(product.price_inr)}</p>
          </div>
          <div className="rounded-lg p-2" style={{ backgroundColor: "#f5f2ec" }}>
            <p className="text-[10px] mb-0.5 flex items-center gap-1" style={{ color: "#4a7068" }}>
              <Clock className="w-2.5 h-2.5" /> Warranty
            </p>
            <p className="font-bold text-sm" style={{ color: "#504136" }}>{product.warranty_years} yr</p>
          </div>
        </div>

        <div>
          <p className="text-[10px] uppercase tracking-wide mb-1.5" style={{ color: "#504136" }}>Connectors</p>
          <div className="flex flex-wrap gap-1">
            <ConnectorChip label="CCS2"     active={product.ccs2} />
            <ConnectorChip label="CHAdeMO"  active={product.chademo} />
            <ConnectorChip label="Bharat DC" active={product.bharat_dc} />
            <ConnectorChip label="Bharat AC" active={product.bharat_ac} />
          </div>
        </div>

        <a
          href={product.website}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-auto flex items-center justify-center gap-1.5 text-xs font-semibold py-2 px-3 rounded-lg border transition-colors"
          style={{ borderColor: "#B2E6D4", color: "#4a7068" }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = "#8ab8b0"; e.currentTarget.style.color = "#689689"; e.currentTarget.style.backgroundColor = "#edf8f4"; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = "#B2E6D4"; e.currentTarget.style.color = "#4a7068"; e.currentTarget.style.backgroundColor = "transparent"; }}
        >
          Visit {product.brand} <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
}

// ── Vendor row card ───────────────────────────────────────────────────────────
function VendorCard({ vendor }) {
  const theme = BRAND_THEMES[vendor.brand] || DEFAULT_THEME;
  const initials = getBrandInitials(vendor.brand);
  const vendorProducts = PRODUCTS.filter(p => p.brand === vendor.brand);

  const isProjectBased = vendor.dc_range?.includes("Project");

  return (
    <div className="rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow" style={{ border: "1px solid #B2E6D4", backgroundColor: "#ffffff" }}>
      <div className="h-1.5" style={{ background: `linear-gradient(90deg, ${theme.from}, ${theme.to})` }} />
      <div className="p-5">
        <div className="flex items-start gap-4 mb-3">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center text-sm font-black text-white flex-shrink-0"
            style={{ background: `linear-gradient(135deg, ${theme.from}, ${theme.to})` }}
          >
            {initials}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center flex-wrap gap-2 mb-0.5">
              <h3 className="font-bold" style={{ color: "#504136" }}>{vendor.brand}</h3>
              {vendor.fame_eligible && (
                <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full" style={{ backgroundColor: "#edf8f4", color: "#689689" }}>FAME II</span>
              )}
            </div>
            <p className="text-[11px]" style={{ color: "#4a7068" }}>{vendor.category} · {vendor.headquarters}</p>
          </div>
          <a
            href={vendor.website}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 flex items-center gap-1 text-xs font-semibold hover:underline"
            style={{ color: "#689689" }}
          >
            Website <ExternalLink className="w-3 h-3" />
          </a>
        </div>

        <p className="text-xs mb-3 leading-relaxed" style={{ color: "#4a7068" }}>{vendor.strengths}</p>

        {/* Price range pills */}
        <div className="flex flex-wrap gap-2 mb-3">
          {!isProjectBased && vendor.dc_range && vendor.dc_range !== "N/A" && (
            <span className="text-[11px] px-2.5 py-1 rounded-full font-medium" style={{ backgroundColor: "#edf8f4", color: "#689689", border: "1px solid #B2E6D4" }}>
              ⚡ DC: {vendor.dc_range}
            </span>
          )}
          {!isProjectBased && vendor.ac_range && vendor.ac_range !== "N/A" && !vendor.ac_range.includes("DC-only") && (
            <span className="text-[11px] px-2.5 py-1 rounded-full font-medium" style={{ backgroundColor: "#f0ede8", color: "#A49E8D", border: "1px solid #e8e3d8" }}>
              〜 AC: {vendor.ac_range}
            </span>
          )}
          {isProjectBased && (
            <span className="text-[11px] px-2.5 py-1 rounded-full font-medium" style={{ backgroundColor: "#f5f2ec", color: "#4a7068", border: "1px solid #B2E6D4" }}>
              Project-based procurement
            </span>
          )}
        </div>

        {/* Product chips */}
        {vendorProducts.length > 0 && (
          <div>
            <p className="text-[10px] uppercase tracking-wide mb-1.5" style={{ color: "#504136" }}>Products in catalog</p>
            <div className="flex flex-wrap gap-1.5">
              {vendorProducts.map((p, i) => (
                <span
                  key={i}
                  className="text-[11px] font-semibold px-2 py-0.5 rounded-lg border"
                  style={{ borderColor: theme.accent + "66", color: theme.to, background: theme.accent + "18" }}
                >
                  {p.power_kw} kW — {p.model}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Main page ─────────────────────────────────────────────────────────────────
export default function ChargerCatalog() {
  const [powerFilter, setPowerFilter] = useState("all");
  const [brandFilter, setBrandFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [view, setView] = useState("products");

  const allBrands = [...new Set(PRODUCTS.map(p => p.brand))].sort();

  const filtered = PRODUCTS.filter(p => {
    if (powerFilter === "ac"  && p.category !== "AC_slow") return false;
    if (powerFilter === "30"  && (p.category === "AC_slow" || p.power_kw > 30)) return false;
    if (powerFilter === "60"  && (p.category === "AC_slow" || p.power_kw < 31 || p.power_kw > 90)) return false;
    if (powerFilter === "120" && (p.category === "AC_slow" || p.power_kw < 91 || p.power_kw > 170)) return false;
    if (powerFilter === "hpc" && p.power_kw < 171) return false;
    if (brandFilter !== "all" && p.brand !== brandFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      if (!p.brand.toLowerCase().includes(q) && !p.model.toLowerCase().includes(q)) return false;
    }
    return true;
  });

  const showTiers = powerFilter === "all" && brandFilter === "all" && !search;

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#f5f2ec" }}>
      <PageSEO
        title="EV Charger Specifications & Comparison — AC & DC Chargers for India"
        description="Compare AC and DC EV chargers available in India. Specs, pricing, dimensions and vendors for 7 kW to 240 kW chargers including Tata, ABB, Exicom, Delta, Greaves and more."
        path="/charger-catalog"
      />

      {/* ── Top nav ── */}
      <header className="sticky top-0 z-30 backdrop-blur" style={{ backgroundColor: "#504136", borderBottom: "1px solid #5e4e41" }}>
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center gap-4">
          <Link to="/dashboard" className="flex items-center gap-2 text-sm transition-colors" style={{ color: "#B2E6D4" }}
            onMouseEnter={e => e.currentTarget.style.color = "#edf8f4"}
            onMouseLeave={e => e.currentTarget.style.color = "#B2E6D4"}
          >
            <ArrowLeft className="w-4 h-4" /> Dashboard
          </Link>
          <div className="h-4 w-px" style={{ backgroundColor: "rgba(255,255,255,0.15)" }} />
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md flex items-center justify-center" style={{ backgroundColor: "#689689" }}>
              <Zap className="w-3.5 h-3.5" style={{ color: "#faf9f6" }} />
            </div>
            <span className="font-semibold text-sm" style={{ color: "#edf8f4" }}>EV Charger Catalog</span>
          </div>
          <div className="ml-auto flex gap-2">
            <button
              onClick={() => setView("products")}
              className="px-4 py-1.5 rounded-full text-xs font-semibold transition-colors"
              style={view === "products"
                ? { backgroundColor: "#689689", color: "#faf9f6" }
                : { backgroundColor: "transparent", color: "#B2E6D4" }
              }
              onMouseEnter={e => { if (view !== "products") e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)"; }}
              onMouseLeave={e => { if (view !== "products") e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              Products
            </button>
            <button
              onClick={() => setView("vendors")}
              className="px-4 py-1.5 rounded-full text-xs font-semibold transition-colors"
              style={view === "vendors"
                ? { backgroundColor: "#689689", color: "#faf9f6" }
                : { backgroundColor: "transparent", color: "#B2E6D4" }
              }
              onMouseEnter={e => { if (view !== "vendors") e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)"; }}
              onMouseLeave={e => { if (view !== "vendors") e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              All Vendors
            </button>
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <section className="relative overflow-hidden" style={{ backgroundColor: "#504136" }}>
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl -translate-y-1/2" style={{ backgroundColor: "rgba(104,150,137,0.3)" }} />
          <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full blur-3xl -translate-y-1/2" style={{ backgroundColor: "rgba(131,232,186,0.2)" }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 pt-16 pb-10 text-center">
          <div className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-semibold mb-6 uppercase tracking-wide" style={{ backgroundColor: "#68968915", border: "1px solid #68968940", color: "#B2E6D4" }}>
            <Zap className="w-3.5 h-3.5" /> India's EV Charging Hardware Directory
          </div>
          <h1 className="text-4xl md:text-5xl font-black mb-4 leading-tight" style={{ color: "#edf8f4" }}>
            Find the Right <span style={{ background: "linear-gradient(90deg, #B2E6D4, #83E8BA)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>EV Charger</span><br />for Your Station
          </h1>
          <p className="text-base max-w-xl mx-auto mb-8" style={{ color: "#B2E6D4" }}>
            Compare {PRODUCTS.length} products from {allBrands.length} leading OEMs — specs, pricing, connectors and FAME&nbsp;II status.
          </p>

          {/* Stats */}
          <div className="inline-flex flex-wrap justify-center gap-6 rounded-2xl px-8 py-4 mb-8" style={{ backgroundColor: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)" }}>
            {[
              { label: "Products",       value: PRODUCTS.length },
              { label: "OEM Brands",     value: allBrands.length },
              { label: "Max Power",      value: `${Math.max(...PRODUCTS.map(p => p.power_kw))} kW` },
              { label: "Market Players", value: OEM_DIRECTORY.length },
            ].map(s => (
              <div key={s.label} className="text-center">
                <p className="text-2xl font-black" style={{ color: "#edf8f4" }}>{s.value}</p>
                <p className="text-xs" style={{ color: "#B2E6D4" }}>{s.label}</p>
              </div>
            ))}
          </div>

          {/* Search */}
          <div className="relative max-w-sm mx-auto">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "#8ab8b0" }} />
            <input
              type="text"
              placeholder="Search brand or model…"
              value={search}
              onChange={e => { setSearch(e.target.value); setView("products"); }}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl text-sm focus:outline-none"
              style={{ backgroundColor: "rgba(255,255,255,0.10)", border: "1px solid rgba(255,255,255,0.15)", color: "#edf8f4" }}
              onFocus={e => { e.currentTarget.style.borderColor = "#83E8BA"; e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.15)"; }}
              onBlur={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)"; e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)"; }}
            />
          </div>
        </div>
      </section>

      {/* ── Filters (products only) ── */}
      {view === "products" && (
        <div className="max-w-7xl mx-auto px-4 py-6 space-y-2" style={{ backgroundColor: "#f5f2ec" }}>
          <div className="flex flex-wrap gap-2">
            {POWER_FILTERS.map(f => (
              <button
                key={f.value}
                onClick={() => setPowerFilter(f.value)}
                className="px-4 py-1.5 rounded-full text-xs font-semibold border transition-colors"
                style={powerFilter === f.value
                  ? { backgroundColor: "#689689", borderColor: "#689689", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", borderColor: "#B2E6D4", color: "#4a7068" }
                }
                onMouseEnter={e => { if (powerFilter !== f.value) { e.currentTarget.style.borderColor = "#8ab8b0"; e.currentTarget.style.backgroundColor = "#edf8f4"; } }}
                onMouseLeave={e => { if (powerFilter !== f.value) { e.currentTarget.style.borderColor = "#B2E6D4"; e.currentTarget.style.backgroundColor = "#ffffff"; } }}
              >
                {f.label}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap gap-1.5">
            <button
              onClick={() => setBrandFilter("all")}
              className="px-3 py-1 rounded-full text-[11px] font-medium border transition-colors"
              style={brandFilter === "all"
                ? { backgroundColor: "#689689", borderColor: "#689689", color: "#ffffff" }
                : { backgroundColor: "#ffffff", borderColor: "#B2E6D4", color: "#4a7068" }
              }
            >
              All Brands
            </button>
            {allBrands.map(b => (
              <button
                key={b}
                onClick={() => setBrandFilter(b)}
                className="px-3 py-1 rounded-full text-[11px] font-medium border transition-colors"
                style={brandFilter === b
                  ? { backgroundColor: "#689689", borderColor: "#689689", color: "#ffffff" }
                  : { backgroundColor: "#ffffff", borderColor: "#B2E6D4", color: "#4a7068" }
                }
                onMouseEnter={e => { if (brandFilter !== b) { e.currentTarget.style.borderColor = "#8ab8b0"; e.currentTarget.style.backgroundColor = "#edf8f4"; } }}
                onMouseLeave={e => { if (brandFilter !== b) { e.currentTarget.style.borderColor = "#B2E6D4"; e.currentTarget.style.backgroundColor = "#ffffff"; } }}
              >
                {b}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ── Content ── */}
      <main className="max-w-7xl mx-auto px-4 pb-20">
        {view === "vendors" ? (
          <div className="grid md:grid-cols-2 gap-5">
            {OEM_DIRECTORY.map((v, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.04 }}
              >
                <VendorCard vendor={v} />
              </motion.div>
            ))}
          </div>
        ) : showTiers ? (
          /* Tier sections when no filters active */
          <div className="space-y-14">
            {POWER_TIERS.map(tier => {
              const tierProducts = PRODUCTS.filter(tier.filter);
              if (!tierProducts.length) return null;
              return (
                <section key={tier.label}>
                  <div className="flex items-center gap-3 mb-6">
                    <div className={`h-1 w-8 rounded-full bg-gradient-to-r ${tier.color}`} />
                    <h2 className="text-lg font-bold" style={{ color: "#504136" }}>{tier.label}</h2>
                    <div className="h-px flex-1" style={{ backgroundColor: "#B2E6D4" }} />
                    <span className="text-xs" style={{ color: "#4a7068" }}>{tierProducts.length} products</span>
                  </div>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                    {tierProducts.map((p, i) => (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.35, delay: i * 0.04 }}
                      >
                        <ProductCard product={p} />
                      </motion.div>
                    ))}
                  </div>
                </section>
              );
            })}
          </div>
        ) : (
          /* Filtered flat grid */
          <>
            <p className="text-sm mb-5" style={{ color: "#4a7068" }}>
              {filtered.length} product{filtered.length !== 1 ? "s" : ""} found
            </p>
            {filtered.length === 0 ? (
              <div className="text-center py-20" style={{ color: "#4a7068" }}>No products match your filters.</div>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {filtered.map((p, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.35, delay: i * 0.04 }}
                  >
                    <ProductCard product={p} />
                  </motion.div>
                ))}
              </div>
            )}
          </>
        )}
      </main>

      <div className="py-6 text-center text-xs" style={{ borderTop: "1px solid #B2E6D4", color: "#4a7068" }}>
        Prices are indicative ex-works estimates (2025–26). Contact vendors directly for quotes. Always verify FAME II / BIS certification before procurement.
      </div>
    </div>
  );
}
